let hostname = window.location.hostname

console.log(hostname);
console.log('dev');

export const environment = {
    production: false,
    config:{
        apiUrl:'https://' + hostname + '/api',
        baseUrl:'https://' + hostname,
        s3Url:'https://s3-api.atos8.com',
        stripePublicKey: 'pk_live_51S2LyaR9173FSaSCqinoI393I2Rc8VnrQvin4SgY28TXFtUXa0kDCn8zzbh8DkD3Fp5bD1iacFnHA2zGTX0MjTWu00iwLtk2IH',
    }
};
